const FEEDBACK_IMAGE_HOST = 'firebasestorage.googleapis.com';

/** https Firebase Storage object under feedback-images/, or null. */
export function safeFeedbackImageUrl(value: string | null | undefined): string | null {
    if (!value || typeof value !== 'string') return null;
    let url: URL;
    try {
        url = new URL(value);
    } catch {
        return null;
    }
    if (url.protocol !== 'https:') return null;
    if (url.username || url.password) return null;
    if (url.hostname !== FEEDBACK_IMAGE_HOST) return null;
    const path = decodeURIComponent(url.pathname);
    if (!/^\/v0\/b\/[^/]+\/o\/feedback-images\/[^/]+$/.test(path)) return null;
    return url.toString();
}
